<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        采购申请
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">费控事前采购申请流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第一步：登录OA系统（oa.xdf.cn，账户密码与个人企业邮箱同步），点击【费用审批】。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第二步：点击【事前采购申请】-【所有已审批采购申请】-【新建】，新建表单。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">费控事前采购申请流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第三步：根据界面提示填写采购需求，完善标星处信息。在【采购事由详细说明】中填写详细收货信息（联系人、联系电话、详细地址等）；根据实际情况选择【业务明细】，完善标星处信息，如需申请多项物资，点击左侧【+】新增后填写；如有附件附件可点击【附件】-【添加】进行上传。确认无误后，点击【确认业务明细填写完毕】-【提交】即可。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">费控事前采购申请流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第四步：点击【事前采购申请】-【所有采购申请】可在业务列表中查看进度。</p>
                    <img src="../../assets/9.jpeg" alt="" class="QRcode">
                    <sup id="box_text_content">长按观看视频教程</sup>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">费控事前采购申请流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第五步：申请部门负责人审批采购</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第六步：机构资产管理部代表审核采购申请</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第七步：采购询价</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第八步：采购申请人核对采购物资</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第九步：采购申请部门负责人/区域总监确认采购物资</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第十步：机构资产管理部代表审核采购物资</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第十一步：机构财务主管会计审批</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">费控事前采购申请流程</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第十二步：机构财务负责人预算审核</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第十三步：机构负责人审批采购</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第十四步：采购执行专员审批</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第十五步：合同审批</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第十六步：借款审批</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第十七步：采购专员执行采购</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">第十八步：报销</p>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        getOnPage1(){
            var name = this.$route.params.name
            if(name == 'as'){
                this.$router.push({name:"IssueManpower2"})
            }else {
                this.$router.push({name:"AssetFlow"})
            }
        },
        fn() {

        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "1001"
                }
            })
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 20px 16px 0;
}
.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30% !important;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#textTitleContent {
    color: #888787;
    font-size: 14px;
}
#box_text_content {
    width: 100%;
    display: block;
    font-size: 12px;
    color: #ccc;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/assetflow/assetFlow3.vue